import { render, staticRenderFns } from "./changeTel.vue?vue&type=template&id=66be927a&scoped=true&"
import script from "./changeTel.vue?vue&type=script&lang=js&"
export * from "./changeTel.vue?vue&type=script&lang=js&"
import style0 from "./changeTel.vue?vue&type=style&index=0&id=66be927a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be927a",
  null
  
)

export default component.exports